var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section section--tour-360"},[_c('div',{staticClass:"container"},[_c('app-heading',{attrs:{"title":"360 Tour","tag":"h2"}}),_c('app-tour360')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }